import type { TranslationTag } from '@ps/web-core-intl';
import { Translation } from '@ps/web-shared-components';
import React from 'react';

import formatValue from '../../../utils/formatTileValue';

import styles from './CountdownTile.scss';

interface Props {
  label: TranslationTag;
  value: number;
}

const CountdownTile: React.FC<Props> = ({ label, value }) => (
  <div className={styles.tile}>
    <div className={styles.tileValue}>{formatValue(value)}</div>
    <div className={styles.tileLabel}>
      <Translation {...label} />
    </div>
  </div>
);

export default React.memo(CountdownTile);
